export const ROLE_KEYS = {
    base: 'roles',
    all: ['roles'],
    list: ['roles', 'list'],
} as const;
